var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"text":_vm._f("timeFromNow")(_vm.value)}},[_vm._v(" "+_vm._s(_vm.formated)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }